import { environment } from '@env';
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserService } from '@shared/modules/account/services/user.service';
import { PreviewService } from '@preview/services/preview.service';

@Injectable()
export class AuthRequestInterceptor implements HttpInterceptor {
  constructor(
    private userService: UserService,
    private readonly previewService: PreviewService
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (request.url.includes(environment.inCloud.baseUrl)) {
      let currentUser = this.userService.currentUserValue;

      if (currentUser && currentUser.accessToken) {
        const previewToken = this.previewService.getToken();
        const token = previewToken ?? currentUser.accessToken;

        const authReq = request.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        });
        return next.handle(authReq);
      }
    }

    return next.handle(request);
  }
}
